import config from "../../config"
import RequestService from "../RequestService"

const fetchWorkflow = (id, successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/workflows/${id}`, successCallback, failureCallback)
}

export default fetchWorkflow;